module.exports = __webpack_public_path__ + "media/images/sipka-918b4b9d3a698e7fe654788c98663400.svg";